import Vue from 'vue';
import VueI18n from 'vue-i18n';
import commonEnUS from './en-US/common.json';
import commonEsCL from './es-CL/common.json';
import commonEsMX from './es-MX/common.json';
import commonEsCO from './es-CO/common.json';

Vue.use(VueI18n);

export default new VueI18n({
  locale: navigator.language,
  silentTranslationWarn: true,
  fallbackLocale: 'es-CL',
  messages: {
    'en-US': {
      common: commonEnUS,
    },
    'es-CL': {
      common: commonEsCL,
    },
    'es-MX': {
      common: commonEsMX,
    },
    'es-CO': {
      common: commonEsCO,
    },
  },
});
